import {
  AppBar,
  Avatar,
  Box,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import UserProfileDialog from "components/topBar/UserProfileDialog";
import {
  appBarSx,
  avatarBorderBoxSx,
  avatarBoxSx,
  avatarSx,
  roleBadgeSx,
  toolbarSx,
  userBoxSx,
  userNameTypographySx,
} from "styles/layouts/TopBar.styles";
import { UserRole } from "types/user.type";
import { ExpandMore } from "@mui/icons-material";
import { roleColors } from "utils/role/roleColors";
import NotificationIcon from "components/notification/NotificationIcon";
import { uploadPaths } from "utils/uploadUrls";
import { useStore } from "stores/useStore";
import { roleLabels } from "utils/role/roleLabels";
import TopBarCalendar from "components/dashboard/TopBarCalendar";

const TopBar = observer(() => {
  const { authStore } = useStore();
  const navigate = useNavigate();
  // const location = useLocation();
  // const isDashboard = location.pathname === "/dashboard";
  const fullName = authStore?.user?.fullName;
  const companyName = authStore?.user?.company?.name || null;
  const showCompany = authStore?.getRole() !== "super_admin";

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
    handleMenuClose();
  };

  const handleLogout = () => {
    authStore.logout(true);
    navigate("/");
  };

  const role: UserRole = (authStore.user?.role as UserRole) || "employee";
  const borderColor: string = roleColors[role] || "gray";
  const roleLabel = roleLabels[role] || role;

  return (
    <>
      <AppBar position="static" elevation={0} sx={appBarSx}>
        <Toolbar sx={toolbarSx}>
          {/* Calendar */}
          <TopBarCalendar />

          <Box sx={userBoxSx}>
            {showCompany && <NotificationIcon />}
            <Typography variant="body1" sx={userNameTypographySx}>
              {fullName}
              {companyName && showCompany && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: "block", fontWeight: "500" }}
                >
                  {authStore.user.company.name}
                </Typography>
              )}
            </Typography>

            <Typography variant="caption" sx={roleBadgeSx(borderColor)}>
              {roleLabel}
            </Typography>

            <Box sx={avatarBoxSx} onClick={handleAvatarClick}>
              <Box sx={avatarBorderBoxSx(borderColor)}>
                <Avatar
                  alt={fullName}
                  src={
                    authStore.user?.profileImage
                      ? uploadPaths.profilePicture(authStore.user.profileImage)
                      : ""
                  }
                  sx={avatarSx}
                />
              </Box>
              <ExpandMore fontSize="small" />
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleOpenDialog}>Paramètres</MenuItem>
              <MenuItem onClick={handleLogout}>Se déconnecter</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <UserProfileDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        role={roleLabel}
        borderColor={borderColor}
      />
    </>
  );
});

export default TopBar;
